const currentYear = new Date().getFullYear();

export const displayYear = (year: number | string) => {
	let parsedYear;
	if (typeof year === 'string') {
		parsedYear = parseInt(year?.replaceAll(/[^0-9-]/g, ''));
	}
	if (typeof year === 'number') {
		parsedYear = year;
	}

	if (!Number.isInteger(parsedYear)) return '';

	if (parsedYear < 0) {
		return `${Math.abs(parsedYear).toLocaleString()} BCE`;
	}
	if (parsedYear >= currentYear) {
		return 'present';
	}
	return `${parsedYear} CE`;
};

export const inputPlaceholderYear = (year: number | string) => {
	let parsedYear;
	if (typeof year === 'string') {
		parsedYear = parseInt(year?.replaceAll(/[^0-9-]/g, ''));
	}
	if (typeof year === 'number') {
		parsedYear = year;
	}

	if (!Number.isInteger(parsedYear)) return '';

	// Because of bad TMS data, pretend future years are "present"
	if (parsedYear >= currentYear) {
		return 'Present';
	}

	if (Math.abs(parsedYear) > 9999) {
		// unlike other numbers, we usually don't write 1,999 CE, but we do write 10,0000 BCE
		return parsedYear.toLocaleString();
	}

	return `${parsedYear}`;
};
